/**
 * Imperatively creates and shows a `<dialog-box>` web component for
 * configuring playback settings. Follows the same pattern as
 * speechSettingsDialog.ts.
 *
 * @param current  Current setting values.
 * @param onChange Called each time a checkbox is toggled.
 */
export function showPlaybackSettingsDialog(current, onChange) {
    const dialog = document.createElement('dialog-box');
    dialog.setAttribute('dialog-title', 'Playback Settings');
    dialog.setAttribute('width', '320');
    dialog.setAttribute('height', '320');
    // --- Content ---
    const content = document.createElement('div');
    content.slot = 'content';
    content.style.padding = '8px 16px';
    content.style.display = 'flex';
    content.style.flexDirection = 'column';
    content.style.gap = '8px';
    const items = [
        { key: 'autoplay', label: 'Autoplay' },
        { key: 'showMarkers', label: 'Show markers in player' },
        { key: 'pauseWhileTyping', label: 'Pause while typing' },
        { key: 'autoCaptions', label: 'Auto-enable captions' },
    ];
    for (const item of items) {
        const checkbox = document.createElement('check-box');
        checkbox.setAttribute('text', item.label);
        if (current[item.key]) {
            checkbox.setAttribute('checked', 'checked');
        }
        checkbox.addEventListener('change', () => {
            onChange(item.key);
        });
        content.appendChild(checkbox);
    }
    dialog.appendChild(content);
    // --- Close handler ---
    dialog.autoKill = true;
    dialog.onCloseHandler = null;
    document.body.appendChild(dialog);
    dialog.show();
}
